/**
 * To blob type.
 * @param blobAsText Blob as text.
 */
export function toExportBlobType(blobAsText: string): Blob {
  return new Blob([blobAsText], { type: 'application/pdf' });
}
